export default "__VITE_ASSET__D9CbtO7b__"